import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { findError } from '@/utils/errors';
import fields from '@/constants/fields';
import CheckboxFormValidationError from '@/components/errors/CheckboxFormValidationError';
import DropdownSegment from '@/components/DropdownSegment';
import { newRequest, resolveRequestWorkflow } from '../../state/state';
import { updateRequestProperties } from '../../actions';
import DestinationNamespaceInput from '../components/DestinationNamespaceInput';
import DestinationNamespaceDropdown from '../components/DestinationNamespaceDropdown';

const SelectDestinationNamespace = ({
  category,
  checked,
  code,
  namespace,
  namespaces,
  saveErrors,
  updateProperties,
}) => {
  const intl = useIntl();
  const namespaceError = findError(saveErrors, 'workspace', [fields.NAMESPACE]);
  const description = intl.formatMessage({ id: `access.namespace.description.${checked ? 'enabled' : 'disabled'}` });

  return (
    <CheckboxFormValidationError
      htmlFor="select_destination_namespace"
      checked={checked}
      labelId="access.namespace.label"
      onClick={() => updateProperties(category, code, { steps: { namespaceSelected: !checked } })}
      error={namespaceError}
    >
      { namespaces.length >= 1 && (
        <DestinationNamespaceDropdown
          disabled={!checked}
          error={namespaceError}
          namespaces={namespaces}
          namespace={namespace}
          onChange={(properties) => updateProperties(category, code, properties)}
        />
      )}
      { namespaces.length === 0 && (
        <DestinationNamespaceInput
          disabled={!checked}
          error={namespaceError}
          value={namespace}
          onChange={(properties) => updateProperties(category, code, properties)}
        />
      )}
      <DropdownSegment
        messageText={description}
        markdown
      />
    </CheckboxFormValidationError>
  );
};

export const mapStateToProps = ({
  requests: { requests }, workflows: { workflows },
}, ownProps) => {
  const { request, source } = resolveRequestWorkflow(requests, workflows, ownProps, newRequest(ownProps));

  return {
    checked: request.steps.namespaceSelected,
    namespace: request.destination_namespace,
    namespaces: source?.namespaces || [],
    saveErrors: request.saveErrors,
  };
};

const mapDispatchToProps = {
  updateProperties: updateRequestProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectDestinationNamespace);
